module.exports = __webpack_public_path__ + "img/right.6495cf8d.png";